module.exports = __webpack_public_path__ + "img/about-4-name.c64a9ebb.png";